import { useState } from 'react';
import { Video } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface LectureThumbnailProps {
  theme?: string;
  title?: string;
  src?: string;
  className?: string;
}

const DEFAULT_THUMBNAIL_IMAGE = '/assets/recorded-classes.png';
const FALLBACK_THUMBNAIL_IMAGE = '/student-overview/record-class.png';

export function LectureThumbnail({
  src = DEFAULT_THUMBNAIL_IMAGE,
  title,
  className,
}: LectureThumbnailProps) {
  const [currentSrc, setCurrentSrc] = useState(src || DEFAULT_THUMBNAIL_IMAGE);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (currentSrc === DEFAULT_THUMBNAIL_IMAGE) {
      setCurrentSrc(FALLBACK_THUMBNAIL_IMAGE);
    } else {
      setHasError(true);
    }
  };

  return (
    <div
      className={cn(
        'relative h-full w-full select-none overflow-hidden bg-slate-900 flex items-center justify-center',
        className,
      )}
    >
      {!hasError ? (
        <img
          src={currentSrc}
          alt={title || 'Lecture Thumbnail'}
          loading="lazy"
          onError={handleError}
          className="h-full w-full object-cover object-center"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-slate-800 text-slate-400">
          <Video className="h-6 w-6 text-slate-300" />
        </div>
      )}
    </div>
  );
}
